(function ($) {
  if (!document.querySelector(".ims-featured-courses-carousel__carousel")) {
    return;
  }

  $(document).ready(() => {
    let $carousels = $(".ims-featured-courses-carousel__carousel");

    $carousels.each((e, carousel) => {
      var $this = $(carousel).find(
        ".ims-featured-courses-carousel__carousel-slides"
      );

      console.log("CAROUSEL", carousel);

      $this.slick({
        dots: false,
        infinite: false,
        speed: 400,
        swipe: false,
        swipeToSlide: false,
        touchMove: false,
        slidesToShow: 1,
        appendArrows: $(carousel).find(".carousel-controls"),

        // Part of the hack in reversing the slider.
        nextArrow:
          '<button class="reset carousel__next-arrow slick-next"><i class="icon icon-arrow-right"></i><div class="sr-only">Previous Course</div></button>',
        prevArrow:
          '<button class="reset carousel__prev-arrow slick-prev"><i class="icon icon-arrow-left"></i><div class="sr-only">Next Course</div></button>',
      });

      var $list = $(carousel)
        .parent()
        .find(".ims-featured-courses-carousel__list-button");

      $this.on("beforeChange", (e, slick, currentSlide, nextSlide) => {
        console.log("NEXT SLIDE", nextSlide);
        $list.removeClass("list-button--active");
        $($list[nextSlide]).addClass("list-button--active");
        scrollToBeVisible(
          $list[nextSlide],
          $(carousel)
            .parent()
            .find(".ims-featured-courses-carousel__list-container")[0]
        );
      });

      $list.on("click", function (e) {
        var index = this.dataset.index;

        $this.slick("slickGoTo", index);
      });
    });
  });

  const scrollToBeVisible = function (ele, container) {
    const eleTop = ele.offsetTop;
    const eleBottom = eleTop + ele.clientHeight;

    const containerTop = container.scrollTop;
    const containerBottom = containerTop + container.clientHeight;

    if (eleTop < containerTop) {
      // Scroll to the top of container
      container.scrollTop -= containerTop - eleTop;
    } else if (eleBottom > containerBottom) {
      // Scroll to the bottom of container
      container.scrollTop += eleBottom - containerBottom;
    }
  };
})(jQuery);



// WEBPACK FOOTER //
// ./assets/js/components/layout/featured-courses-carousel.js